module.exports = __webpack_public_path__ + "550b1127dc0febc99586d44e729e2780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s22.jpg
// module id = 698
// module chunks = 0